<template>
  <div class="header">
    <div class="block">
      <img
        src="../assets/dachstein-logo.png"
        alt="dachstein-logo"
      >
      <div class="headerleft">
        <a
          href="https://www.derdachstein.at/de"
          target="_blank"
        >
          <font-awesome-icon
            icon="globe"
            size="lg"
          />
          <p>Website</p>
        </a>
        <a href="tel:+43 3687 / 22 0 42 ">
          <font-awesome-icon
            icon="phone"
            size="lg"
          />
          <p>Hotline</p>
        </a>
        <!-- LEFT HEADER -->
      </div>
    </div>
    <div class="headerright">
      <div class="columns">
        <div class="column"/>
        <!--<div class="column is-one-third"><a href="https://www.derdachstein.at/de" target="_blank">-->
        <!--<font-awesome-icon icon="language" size="lg" style="margin-bottom: 3px" /><br>Sprache</a>-->
        <!--</div>-->
        <div class="column"/>
      </div>
      <!-- RIGHT HEADER -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    msg: {
      type: String,
      default: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header {
  width: 100%;
  height: auto;
  padding: 1rem 1rem 0.7rem 1rem;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 6px rgba(25, 25, 25, 0.25);
  text-align: center;
  position: relative;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;

  img {
    height: 52px;
  }

  .block {
    position: relative;
    padding: 0;
    margin-bottom: 0;

    .headerleft {
      display: flex;
      justify-content: space-around;
      position: absolute;
      right: auto;
      top: 50%;
      transform: (translateY(-50%));

      > a {
        color: #969696;
        transition: color .5s;
        display: flex;
        align-items: center;
        flex-direction: column;

        &:first-child {
          margin-right: 1em;
        }

        svg {
          fill: #969696;
          transition: fill .5s;
        }

        &:hover,
        &:focus {
          color: #004e9f;
          transition: color .5s;

          svg {
            fill: #004e9f;
            transition: fill .5s;
          }
        }

        p {
          margin-top: 5px;
          display: none;
          font-size: 13px;
        }
      }
    }
  }
}

@media (min-width: 1000px) {
  .header .block .headerleft {
    right: 100%;

    a > p {
      display: block;
    }
  }
}


@media (max-width: 680px) {
  .header {
    padding: 0.6rem 1rem 0.4rem 1rem;

    img {
      height: 35px;
    }

  }
}
</style>


